<template>
<div>
  <ed-modal 
      :modal="showModal" 
      :title="(formData ? 'IMPRIMIR GUIA DE ENCAMINHAMENTO OU ASO - CONSULTA Nº '+formData.id_con : '')"
      width="80%"
    >
      <div slot="modal-content" v-if="formData" v-loading="loadingContent">
        
        <ed-alert
          color="warning"
          icon="info"
          class="mb-3"
          title="Atenção"
        >
          <div slot="description">
            <p>
              Disponibilizamos abaixo algumas opções para você visualizar as Guias de Encaminhamento ou o ASO dessa consulta.
              <br>
              Certifique-se que seu navegador esteja liberado para abrir os POP-UP desse sistema. Para mais informações acesse <a href="https://support.google.com/chrome/answer/95472?hl=pt-BR" target="_blank">clique aqui</a>
            </p>
          </div>
        </ed-alert>

        <el-tabs type="border-card" v-model="tabSelected">

        <el-tab-pane label="Imprimir ASO" name="tab-guia" v-if="formData && formData.tipo_status.id == 54">
          <span slot="label"><i class="fa fa-print"></i> Imprimir Guia de Encaminhamento</span>

          <div class="col-md-12" v-if="formData">
            
            <ed-alert
              type="warning"
              class="mb-3"
              message="Atenção"
            >
              <div slot="description">
                <p>
                  Esse Guia de Encaminhamento não garante atendimento na clínica. Por favor imprimir esse Guia e entregar ao funcionário para apresentar na hora do atendimento.
                </p>
              </div>
            </ed-alert>

            <ed-button
                icon="fa fa-print"
                title="Clique Aqui para Imprimir"
                @click="onGuia"
                value="Imprimir"
            />

          </div>

        </el-tab-pane>

        <el-tab-pane label="Imprimir ASO" name="tab-aso">
          <span slot="label"><i class="fa fa-print"></i> Imprimir ASO</span>

          <div class="col-md-12" v-if="formData">

            <ed-button
                v-if="formData && formData.id_con && (formData.tipo_status.id == 66 || formData.tipo_status.id == 67)"
                icon="fa fa-print"
                title="Clique Aqui para Imprimir"
                @click="onAso"
                :disabled="formData.tipo_status.id != 66 && formData.tipo_status.id != 67"
                value="Imprimir"
            />

            <ed-alert
              v-else
              type="error"
              class_name="q-mb-lg"
              message="Atenção"
            >
              
              <div slot="description">
                <p>
                  Esse ASO ainda não foi liberado. Você será notificado por email quando o ASO estiver liberado.
                  <span v-if="formData.credenciada.tel_com">
                    Para maiores informações entre com {{formData.credenciada.nome.toUpperCase()}} pelo telefone 
                    {{formData.credenciada.tel_com}}
                  </span>
                  <span v-else>
                    Para maiores informações entre com {{formData.credenciada.nome.toUpperCase()}}
                  </span>
                </p>
              </div>
            </ed-alert>

          </div>

        </el-tab-pane>

        <!-- <el-tab-pane label="Imprimir Guia de Encaminhamento" name="tab-acomp" v-if="false && formData && formData.tipo_status.bloqueado == 0">
          <span slot="label"><i class="fa fa-print"></i> Imprimir Guia de Encaminhamento</span>
          
          <ed-alert
              v-if="formData && formData.tipo_status.id != 54 && formData.tipo_status.id != 55"
              type="error"
              class_name="q-mb-lg"
              message="Atenção"
            >
              
              <div slot="description">
                <p>
                  Esse GUIA não pode ser visualizado porque o atendimento já foi encerrado.
                  <span v-if="formData.credenciada.tel_com">
                    Para maiores informações entre com {{formData.credenciada.nome.toUpperCase()}} pelo telefone 
                    {{formData.credenciada.tel_com}}
                  </span>
                  <span v-else>
                    Para maiores informações entre com {{formData.credenciada.nome.toUpperCase()}}
                  </span>
                </p>
              </div>
          </ed-alert>

          <div class="col-md-12" v-else-if="formData">
              <span v-for="(item,i) in parceiros" :key="i" style="display: block;">
                
                <el-badge :value="item.exames.length" class="item mb-3" :title="item.exames.length+' exame(s) encontrado(s)'">
                  <ed-button
                    icon="fa fa-print"
                    :title="item.parceiro.nome"
                    :disabled="formData.tipo_status.id != 54 && formData.tipo_status.id != 55"
                    :value="item.parceiro.nome"
                    type="default"
                    @click="onGuia(item.parceiro)"
                  />
                </el-badge>

                
              </span>
          </div>
        </el-tab-pane> -->

      </el-tabs>

      </div>
  </ed-modal>
</div>
</template>

<script>

import Rest from 'common/rest'
import EdModal from 'common/modal'
import EdAlert from 'common/alert'
import EdButton from 'common/button'

export default {
    name: 'EmpresaCadastro',
    components:{EdModal,EdAlert,EdButton},
    mixins:[Rest],
    props:{
      consulta:{
        type: Object,
        default: {}
      },
      showGuia:{
        type: Boolean,
        default: false
      },
    },
    watch:{
      'consulta.id'(){
        this.getConsulta();
      },
      showGuia(){
        this.showModal = !this.showModal;
      }
    },
    data () {
      return{
        showModal:false,
        loadingContent:false,
        formData:null,
        tabSelected:'tab-guia',
        parceiros:[]
      }
    },

    created(){
    },
    mounted(){
      this.getConsulta();
    },

    methods: {

      onAso(){
        this.open('consulta/aso/'+this.toMd5(this.formData.id_con));
      },

      onGuia(parceiro){
        this.open('consulta/externa/guia/'+this.toMd5(this.formData.id));
      },

      getConsulta(){
        
        if(!this.consulta || !this.consulta.id)return;

        this.loadingContent = true;

        this.get("consulta/externa/"+this.consulta.id).then(result =>{

          result = result[0];
          this.loadingContent = false;

          if(result.status == 200){
            this.formData = result.data;
            this.formataParceiro();

            if(this.formData && this.formData.tipo_status.id == 54){
              this.tabSelected = 'tab-guia';
            }
            else{
              this.tabSelected = 'tab-aso';
            }
          }
        });
      },

      formataParceiro(){
        var consulta = this.formData, parceiros = {};

        try {
          consulta.exames = consulta.exames.sort((a,b) => (a.parceiro.nome > b.parceiro.nome) ? 1 : ((b.parceiro.nome > a.parceiro.nome) ? -1 : 0)); 
        } catch (error) {}
        
        for (let i = 0; i < consulta.exames.length; i++) {
          var 
            consulta_exame = consulta.exames[i], 
            index = null;

          if(consulta_exame.parceiro && consulta_exame.id_con_rea == 0 && consulta_exame.id_con_dem == 0){

            index = this.toMd5(consulta_exame.parceiro.id);

            if(!parceiros[index]){
              parceiros[index] = {
                parceiro:consulta_exame.parceiro,
                exames:[]
              };
            }
            parceiros[index]['exames'].push(consulta_exame.exame)
          }
          
        }
        this.parceiros = parceiros;
      }
      
    }
}
</script>


// WEBPACK FOOTER //
// guia.vue?e3d90b30